export default "__VITE_ASSET__CgkAvIns__"